export default __webpack_public_path__ + "static/media/itachi.8c6cfdf8.png";